module.exports = __webpack_public_path__ + "static/media/videoLogo.6f135bad.png";